import { Ajaxinate } from '../../node_modules/ajaxinate';
import { openSMSPopup } from './klavijo-sms-popup';
document.addEventListener("DOMContentLoaded", function () {
  //<Scroll infinity>
  new Ajaxinate({
    container: '#CollectionLoop',
    pagination: '#pagination-custom.pagination-new',
    loadingText: 'Loading...',
    method: 'scroll',
    offset: 1000
  });
  //</Scroll infinity>
  //<PDP swiper-slide-product>
  var swiperSlideProductThumb;
  var swiperProductMain;
  function initSwipersProduct() {
    var isMobile = window.innerWidth <= 768;

    // Destroy if they already exist
    if (swiperSlideProductThumb) swiperSlideProductThumb.destroy(true, true);
    if (swiperProductMain) swiperProductMain.destroy(true, true);

    // create the thumbs
    swiperSlideProductThumb = new Swiper(".swiper.product-media__main-thumbs", {
      direction: isMobile ? 'horizontal' : 'vertical',
      centeredSlides: false,
      centeredSlidesBounds: false,
      centerInsufficientSlides: false,
      loop: false,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      freeMode: false,
      //spaceBetween: isMobile ? 10 : 30,
      spaceBetween: 4,
      slidesPerView: 6,
      slidesOffsetAfter: 0
    });

    // main slide
    swiperProductMain = new Swiper(".swiper.product-media__swiper", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      spaceBetween: 3,
      keyboard: {
        enabled: true
      },
      navigation: {
        nextEl: ".slide-product.swiper-button-next",
        prevEl: ".slide-product.swiper-button-prev"
      },
      thumbs: {
        swiper: swiperSlideProductThumb
      }
    });
  }

  // Initialize on loading
  initSwipersProduct();

  // Recalculate in resize
  var resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      initSwipersProduct();
    }, 200);
  });

  //</PDP swiper-slide-product>

  openSMSPopup();
});